'use client';

/**
 * Schermata di commiato — 3940 non è più operativo, le prove RIPAM
 * 3.997 Ass. AMM sono terminate. Nessun link: pagina statica, annuncio
 * della migrazione verso Plotyno.
 */

export default function WelcomePage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-6 bg-white">
      <h1 className="text-6xl font-black tracking-tight mb-4">
        <span className="text-orange-500">39</span><span className="text-slate-900">40</span>
      </h1>

      <p className="text-sm text-slate-600 max-w-md leading-relaxed text-left text-justify">
        Le prove RIPAM 3.997 posti - Ass. Amm sono terminate. In circa due mesi dal suo lancio 3940 è stato strumento di studio di oltre cento candidati, con migliaia di accessi, decine di migliaia di quiz, due metodi di studio e centinaia di simulazioni. Augurando il miglior successo ai nostri user, l'esperienza 3940 migra in "Plotyno", la nascente piattaforma di studio verticale per concorsi ed altro.
      </p>
      <p className="text-sm text-slate-600 italic max-w-md leading-relaxed text-left text-justify mt-4">
        Se sei un utente di 3940, per accedere a Plotyno puoi fare direttamente login usando la stessa email e password.
      </p>
      <a
        href="https://plotyno.com"
        className="flex items-center gap-3 mt-8"
      >
        <img src="/plotyno-icon.png" alt="" className="w-14 h-14" />
        <span className="text-5xl font-black text-orange-500 hover:text-orange-400 transition">
          Plotyno
        </span>
      </a>
      <a
        href="https://plotyno.com"
        className="text-sm text-slate-400 hover:text-slate-500 transition mt-2"
      >
        plotyno.com
      </a>
    </div>
  );
}